module.exports = __webpack_public_path__ + "media/icons/open-eye-4abcc0dc.svg";